import type { JSX } from "solid-js";
import Text from "../../text/Text";
import { Icon } from "../../icon/Icon";
import type { IconOption } from "../../../types/Menu";

const IconSelectValue = (props: Omit<IconOption<null>, "value">): JSX.Element => (
  <div class="flex min-w-0 items-center gap-x-1.5 select-none">
    <div class="inline-flex items-center justify-center icon-tertiary">
      <span class={`size-5 shrink-0 rounded-sm ${props.icon.class ?? ""}`} style={props.icon.style}>
        <Icon name={props.icon.name} type={props.icon.type} size="lg" />
      </span>
    </div>
    <Text as="span" truncate text={props.label} class="text-base-medium text-primary group-disabled:text-disabled" />
  </div>
);

export default IconSelectValue;
